import { DealStateEnum } from '../gql/dealGql';

// Keep in sync with API: types/dealDates.ts
export type Dates = {
  [key in DealStateEnum]?: string;
};
type CustomDateKey =
  | DealStateEnum
  | 'wet_sig_sent_date'
  | 'wet_sig_received_date'
  | 'sent_to_audit'
  | 'temporary_registration_tags_sent_date'
  | 'temporary_registration_tags_expiration_date';
export type CustomDates = {
  [key in CustomDateKey]?: string;
};

export class DealDates {
  id?: number;
  deal_id?: number;
  dates?: Dates | null;
  custom_dates?: CustomDates | null;

  constructor() {
    this.id = 0;
    this.deal_id = 0;
    this.dates = {};
    this.custom_dates = {};
  }
}
